exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "reports-grid {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n}\n\n.grouping-box {\n  margin-right: 30px;\n}\n\n.unread-switch-box {\n  margin-right: 50px;\n}\n\n.toolbox {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  padding-left: 8px;\n  padding-top: 8px;\n}\n\n.toolbox .toolbox-items {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.toolbox grid-legend {\n  flex-grow: 1;\n}\n\n", ""]);

// exports
